// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import bootstrapForms from './modules/Forms/bootstrapForms'
import PrivacyModal from './modules/Utils/privacy_modal'


//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
// Modal de Política de Privacidade (footer + banner de cookies)
PrivacyModal();
//forms
bootstrapForms();
// Layout
Footer()

// Animations
// ScrollSmooth() desativado: a LP (page_home.js) cria a própria instância Lenis
// com integração ao GSAP ScrollTrigger (stop/start nos modais, scrollTo no form).
// Duas instâncias Lenis simultâneas quebram o smooth scroll.
// ScrollSmooth()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
// AnchorLinks() desativado: o setSmoothScrollTo dele (setInterval com window.scroll
// por 1s em URLs com #hash) briga com o Lenis da LP. As âncoras da LP são
// interceptadas no page_home.js e roladas via lenis.scrollTo.
// AnchorLinks()
